export default "__VITE_ASSET__DZ7pGLwe__"